import * as React from 'react'
import { I18nService } from '../../../services/utils/i18n.service'
import FlashComponent from './flash.component'
import TooltipComponent from '../tooltip.component'

interface Props {
  store_incomplete_reasons: string[]
}

const i18nScoped = new I18nService(require('./flash-incomplete-store.component.yml'))

export default function FlashIncompleteStoreComponent ({ store_incomplete_reasons }: Props) {
  const content = React.useMemo(
    () => {
      if (window.currentUser?.type !== 'Operator') return i18nScoped.t('store_incomplete')

      const tooltipProps: Record<'innerStyle' | 'style', React.CSSProperties> = {
        innerStyle: { width: 'max-content', left: 0, right: 0, margin: 'auto' },
        style: { justifyContent: 'center' }
      }

      return <TooltipComponent { ...tooltipProps } message={ store_incomplete_reasons }>
        {i18nScoped.t('store_incomplete')}
      </TooltipComponent>
    },
    [store_incomplete_reasons]
  )

  return <FlashComponent type="error" fixed content={ content } />
}
